import React from 'react';
const kennitala = require('kennitala')
import { setMultiState, toggleType, clearPerson } from '../../api/offers/actions'
import { formatKennitala, formatMoney, customerNameById, summarizeOfferCheckboxes, getPersonTypeByAge, getPersonAge } from '../../utils'
import { SvgCloseIcon } from '../svg';
import { CONTRACT_STATUS_WAITING, CONTRACT_STATUS_ACTIVE, CONTRACT_STATUS_INACTIVE } from '../../constants';
import moment from 'moment'
import AttachDocumentModal from '../attach-document-modal';
import { AdditionalQuestionsModal } from '../modals'


const generateTooltipText = (contract) => {
    let tooltipText = ""
    if(["VID", "VIDE"].includes(contract.ContractType)){
        tooltipText += `<br /> Samningsárafjöldi: ${contract.ContractYears}`
        tooltipText += `<br /> Launþegi: ${contract.EmployeeContributionPct}%`
        tooltipText += `<br /> Launagreiðandi: ${contract.EmployerContributionPct}%`
        tooltipText += `<br /> Síðasta skilagrein: ${contract.LastDeclarationPayment ? contract.LastDeclarationPayment : 'Engin'}`
    }
    if(["VIDT"].includes(contract.ContractType)){
        tooltipText += `<br /> Síðasta skilagrein: ${contract.LastDeclarationPayment ? contract.LastDeclarationPayment : 'Engin'}`
    }
    if(["REN", "FOR", "RENE", "FORE"].includes(contract.ContractType)){
        tooltipText += `<br /> Samningsárafjöldi: ${contract.ContractYears}`
        tooltipText += `<br /> Iðgjald: ${formatMoney(contract.PremiumAmountCur, 2)}€`
        tooltipText += `<br /> Dánarbætur v. slyss: ${formatMoney(contract.LifeInsuranceAmountCur)}€`
    }
    if(["RISLEB", "LEB"].includes(contract.ContractType)){
        tooltipText += `<br /> Iðgjald: ${formatMoney(contract.PremiumAmountCur, 2)}€`
        tooltipText += `<br /> Líftrygging: ${formatMoney(contract.AssuranceAmountCur)}€`
        tooltipText += `<br /> Dánarbætur v. slyss: ${formatMoney(contract.LifeInsuranceAmountCur)}€`
    }
    if(["RIS", "RISU"].includes(contract.ContractType)){
        tooltipText += `<br /> Samningsárafjöldi: ${contract.ContractYears}`
        tooltipText += `<br /> Iðgjald: ${formatMoney(contract.PremiumAmountCur, 2)}€`
        tooltipText += `<br /> Grunnörorkubætur: ${formatMoney(contract.DisabilityInsuranceAmountCur)}€`
        tooltipText += `<br /> Dánarbætur v. slyss: ${formatMoney(contract.LifeInsuranceAmountCur)}€`
    }
    if(["KSP"].includes(contract.ContractType)){
        tooltipText += `<br /> Samningsárafjöldi: ${contract.ContractYears}`
        tooltipText += `<br /> Iðgjald: ${formatMoney(contract.PremiumAmountCur)}€`
    }
    if(contract.Alternatives){
        tooltipText += `<br /> Frávik: ${contract.Alternatives}`
    }
    return tooltipText
}


class ContractTypeInput extends React.Component {

	constructor(props) {
		super(props)
	}

	handleChange(event) {
		let params = event.target.id.split("-")
		this.props.dispatch(setMultiState(
			[{ key: params[1], value: event.target.checked }]
			, params[0])
		)
	}


	render() {
		let contracts = this.props.contracts
		let customer = this.props.customer
		let _contractType = this.props.contractType
		let customerId = this.props.customerId
		let customers = customers
		let contractType = null

		if (this.props.multiTypes) {
			const intersection = ["FOR", "FORE", "RIS", "RISU"].filter(element => _contractType.includes(element));
			if (getPersonTypeByAge(customerId) === "child" && intersection.length === 0) {
				return null
			}
			// exclude 16 and 17 year olds from FOR, FORE
			const intersection2 = ["FOR", "FORE"].filter(element => _contractType.includes(element))
			if (getPersonTypeByAge(customerId) === "child" && intersection2.length > 0 && getPersonAge(customerId) >= 16) {
				return null
			}
			if (getPersonTypeByAge(customerId) === "adult" && intersection2.length > 0) {
				return null
			}
			contractType = _contractType[0]

		}
		else {
			if (getPersonTypeByAge(customerId) === "child" && !["FOR", "FORE", "RIS", "RISU"].includes(_contractType)) {
				return null
			}
			// exclude 16 and 17 year olds from FOR, FORE
			if (["FOR", "FORE"].includes(_contractType) && getPersonTypeByAge(customerId) === "child" && getPersonAge(customerId) >= 16) {
				return null
			}
			contractType = _contractType
		}

		let contract = getContractByType(contracts, _contractType)
		let classNames = "status-indicator"
		let disabled = false
		disabled = this.props.disabled === true && true

		var tooltipText = ""
		if (this.props.disabled === true && this.props.disabledText !== undefined) {
			tooltipText = this.props.disabledText
		}

        if (contract) {
            disabled = false
            let contractName = contract.ContractName || '';
            contractName = contractName.lastIndexOf(',') != -1 ? contractName.substr(0,contractName.lastIndexOf(',')) : contractName;

            if (CONTRACT_STATUS_ACTIVE.includes(contract.ContractStatusId) && ["VID", "VIDE", "VIDT", "VIDTE", "REN", "FOR", "RENE", "FORE", "RISLEB", "LEB", "RIS", "RISU", "KSP"].includes(contract.ContractType)) {
                classNames = `${classNames} active`
                tooltipText = `${contractName} <br/>Virkur ${contract.StartDate ? contract.StartDate.format("D. M. YYYY") : ""}<br />${contract.ContractStatus}`
            } else if (CONTRACT_STATUS_WAITING.includes(contract.ContractStatusId)) {
                classNames = `${classNames} inactive`
                tooltipText = `${contractName} <br/>Biðstaða ${contract.StartDate ? contract.StartDate.format("D. M. YYYY") : ""}<br />${contract.ContractStatus}`
            }
            if (CONTRACT_STATUS_INACTIVE.includes(contract.ContractStatusId)) {
                classNames = `${classNames} closed`
                tooltipText = `${contractName} <br/>Lokaður ${contract.StartDate ? contract.StartDate.format("D. M. YYYY") : ""}<br />${contract.ContractStatus}`
            }

			tooltipText += generateTooltipText(contract)

		}

		return (
			<>
				{window.md.phone() ?
					// farsími
					<span className="d-inline-block nowrap">
						<input type="checkbox" id={`${customerId}-${contractType}-`} className={classNames} name={`${customerId}[]`} value={contractType} disabled={disabled} onChange={this.handleChange.bind(this)} checked={this.props.checked} />
						<label htmlFor={`${customerId}-${contractType}-`}>{contractType}</label>
					</span>
					:
					// desktop
					<span className="d-inline-block nowrap" data-toggle={tooltipText === "" ? "" : "tooltip"} data-original-title={tooltipText} title={tooltipText}>
						<input type="checkbox" id={`${customerId}-${contractType}-`} className={classNames} name={`${customerId}[]`} value={contractType} disabled={disabled} onChange={this.handleChange.bind(this)} checked={this.props.checked} />
						<label htmlFor={`${customerId}-${contractType}-`}>{contractType}</label>
					</span>
				}
			</>
		)
	}
}

const getContractByType = (contracts, contractType) => {
    let altContractType = ""
    
    if (contractType instanceof Array) {
        altContractType = contractType[1]
        contractType = contractType[0]
    } else {
        if(["FORE", "RENE", "VIDE", "RISU"].includes(contractType)) {
            altContractType = contractType.substr(0, contractType.length - 1)
        }
    }
    // Gets the last contract in the list
    if (contracts.hasOwnProperty(altContractType)) {
        return contracts[altContractType][contracts[altContractType].length - 1]
    } 
    if (contracts.hasOwnProperty(contractType)) {
        return contracts[contractType][contracts[contractType].length - 1]
    }
    else {
        return null
    }
}


class ViewContracts extends React.Component {

	constructor(props) {
		super(props)

		this.state = {
			otherContractsToggler: {},
			modalsShown: {}
		}

		this.clearPerson = this.clearPerson.bind(this)
		this.toggleType = this.toggleType.bind(this)
	}

	componentDidUpdate() {
		$('[data-toggle="tooltip"]').tooltip({ html: true, boundary: 'window' })
	}

	clearPerson(kennitala) {
		this.props.dispatch(clearPerson(kennitala))
	}

	toggleType(insuranceType, customerIds) {
		this.props.dispatch(toggleType(insuranceType, customerIds))
		// $(`input[id*=-${insuranceType}-`).click()
	}

	toggleOtherContracts(kennitala) {
		const { otherContractsToggler } = this.state;
		otherContractsToggler[kennitala] = !otherContractsToggler[kennitala]
		this.setState({ otherContractsToggler })
	}

	renderOtherContracts(customerKennitala, kennitala) {
		const contractStatusFormat = (contract) => {
			let statusClass = '', text = '';
			if (CONTRACT_STATUS_INACTIVE.includes(contract.ContractStatusId)) {
				statusClass = 'inactive'
				text = 'Lokaður'
			} else if (CONTRACT_STATUS_WAITING.includes(contract.ContractStatusId)) {
				statusClass = 'pending'
				text = 'Biðstaða'
			} else if (CONTRACT_STATUS_ACTIVE.includes(contract.ContractStatusId)) {
				statusClass = 'active'
				text = 'Virkur'
			}
			return {
				statusClass,
				text
			}
		}

		const renderAdditionalQuestions = (contract) => {
			// Display button for RISLEB, LEB, REN if not closed
			return !CONTRACT_STATUS_INACTIVE.includes(contract.ContractStatusId) && ['RISLEB', 'LEB', 'REN'].includes(contract.ContractType)
		}

		let tooltipText = ""

		return <>
			{this.state.otherContractsToggler[kennitala] ?
				<tr>
					<td colSpan="10" className={`other-contracts-container ${this.state.otherContractsToggler[kennitala] ? 'open' : ''}`}>
						<div>
							<table>
								<thead>
									<tr>
										<th>Tryggingartaki</th>
										<th>Tryggingarþegi</th>
										<th>Samningsgerð</th>
										<th>Staða</th>
										<th className="text-right">Dags</th>
									</tr>
								</thead>
								<tbody>
									{Object.keys(customerKennitala).map(contractKey =>
										customerKennitala[contractKey].map(contract => {

											let contractName = contract.ContractName || contract.ContractType;
											contractName = contractName.lastIndexOf(',') != -1 ? contractName.substr(0,contractName.lastIndexOf(',')) : contractName;


											tooltipText = `${contractName} <br/>${contractStatusFormat(contract).text} ${contract.StartDate ? contract.StartDate.format("D. M. YYYY") : ""}`
											tooltipText += generateTooltipText(contract)

											return <tr key={`others-contract-line-${contract.ContractId}`}>
														<td >{contract.InvoiceCustName} ({contract.InvoiceAccount})</td>
														<td >{contract.CustName} ({contract.CustAccount})</td>
														<td >{contract.ContractType}</td>
														<td >
															<span className={`contract-status ${contractStatusFormat(contract).statusClass}`} data-toggle={tooltipText === "" ? "" : "tooltip"} data-original-title={tooltipText} title={tooltipText}>{contractStatusFormat(contract).text}</span>
														</td>
														<td className="text-right">{moment.utc(contract.StartDate).format('D.M.YYYY')}</td>
														<td className="text-right">
															<button style={{width: "154px"}}className="btn btn-sm btn-warning" onClick={() => this.setState({ modalsShown: { ...this.state.modalsShown, [contract.ContractId]: 'document' } })}>Bæta við skjali</button>
															{renderAdditionalQuestions(contract) &&
																<button className="btn btn-sm btn-primary" onClick={() => this.setState({ modalsShown: { ...this.state.modalsShown, [contract.ContractId]: 'questionnaire' } })}>Bæta við spurningalista</button>
															}
															{this.state.modalsShown[contract.ContractId] == 'document' &&
																<AttachDocumentModal modalId={"AttachDocumentModal-" + contract.ContractId} contractId={contract.ContractId} dispatch={this.props.dispatch} contracts={this.props.contracts} modalHidden={() => this.setState({ modalsShown: { ...this.state.modalsShown, [contract.ContractId]: false } })} />
															}
															{this.state.modalsShown[contract.ContractId] == 'questionnaire' &&
																<AdditionalQuestionsModal
																	modalId={"AdditionalQuestionsModal-" + contract.ContractId}
																	contractId={contract.ContractId} dispatch={this.props.dispatch}
																	contracts={this.props.contracts}
																	modalHidden={() => this.setState({ modalsShown: { ...this.state.modalsShown, [contract.ContractId]: false } })}
																/>
															}
														</td>
                                                    </tr>
										})
									)}
								</tbody>
							</table>
						</div>
					</td>
				</tr>
				:
				<></>
			}
		</>
	}

	render() {
		let customers = this.props.customers;
		let customer = this.props.customers.lastLookup

		let customerKennitalas = customers.customerList.reduce((acc, current) => {
			let lst = Object.keys(current.ContractsByKennitala).map(kennitala => {
				if (kennitala !== "Name") { return kennitala }
			}).filter(i => i !== undefined)
			return acc.concat(lst)
		}, [])

		let showPartner = customers.customerList.filter(c => c.type !== "child").length >= 2
		showPartner = false

		let checkBoxes = summarizeOfferCheckboxes(this.props.offers.offerQueryParameters)

		return (
			<>
				<div className="row insurance-table-container">
					<div className="col-12">
						<table className="table col-1-left col-2-left text-center insurance-overview-table">
							<colgroup>
								<col width="24%" className="insurance-info" />
								<col width="20%" className="insurance-info ssn-container" />
								<col width="8%" className="insurance-selectors" />
								<col width="8%" className="insurance-selectors" />
								<col width="8%" className="insurance-selectors" />
								<col width="8%" className="insurance-selectors" />
								<col width="8%" className="insurance-selectors" />
								<col width="8%" className="insurance-selectors" />
								<col width="8%" className="insurance-selectors" />
							</colgroup>
							<thead>
								<tr>
									<th className="name-title">Nafn</th>
									<th className="ssn-title">Kennitala</th>
									<th>VID</th>
									<th>VIDT</th>
									<th>REN</th>
									<th>RISLEB</th>
									<th>RIS</th>
									{/* <th>KSP</th> */}
									<th>LEB</th>
									<th>FOR</th>
								</tr>
							</thead>
							<tbody>

								{customers.customerList.map(customer =>
									Object.keys(customer.ContractsByKennitala).filter(item => item !== "Name").map((kennitala, key) =>
										<React.Fragment key={key}>
											<tr>
												<td className="name">
													<span>{customerNameById(kennitala, customers)}</span>
													<span>{formatKennitala(kennitala)} </span>
													<a role="button" className="close-btn" onClick={() => this.clearPerson(kennitala)}><SvgCloseIcon /></a>
												</td>
												<td className="ssn">{formatKennitala(kennitala)}
													<a role="button" className="close-btn" onClick={() => this.clearPerson(kennitala)}>
														<SvgCloseIcon />
													</a>
												</td>
												<td>{customer.type !== "child" && <ContractTypeInput dispatch={this.props.dispatch} contractType={"VID"} contracts={customer.ContractsByKennitala[kennitala]} customer={customer} customerId={kennitala} checked={checkBoxes.includes(`${kennitala}-VID`)} />}</td>
												<td>{customer.type !== "child" && <ContractTypeInput dispatch={this.props.dispatch} contractType={"VIDT"} contracts={customer.ContractsByKennitala[kennitala]} customer={customer} customerId={kennitala} checked={checkBoxes.includes(`${kennitala}-VIDT`)} />}</td>
												<td>{customer.type !== "child" && <ContractTypeInput dispatch={this.props.dispatch} contractType={"REN"} contracts={customer.ContractsByKennitala[kennitala]} customer={customer} customerId={kennitala} checked={checkBoxes.includes(`${kennitala}-REN`)} />}</td>
												<td>{customer.type !== "child" && <ContractTypeInput dispatch={this.props.dispatch} contractType="RISLEB" contracts={customer.ContractsByKennitala[kennitala]} customer={customer} customerId={kennitala} checked={checkBoxes.includes(`${kennitala}-RISLEB`)} />}</td>
												<td><ContractTypeInput dispatch={this.props.dispatch} contractType={["RIS", "RISU"]} multiTypes={true} contracts={customer.ContractsByKennitala[kennitala]} customer={customer} customerId={kennitala} checked={checkBoxes.includes(`${kennitala}-RIS`)} /></td>
												{/* <td>{customer.type !== "child" && <ContractTypeInput dispatch={this.props.dispatch} contractType="KSP" contracts={customer.ContractsByKennitala[kennitala]} customer={customer} customerId={kennitala} checked={checkBoxes.includes(`${kennitala}-KSP`)} />}</td> */}
												<td>{customer.type !== "child" && <ContractTypeInput dispatch={this.props.dispatch} contractType="LEB" contracts={customer.ContractsByKennitala[kennitala]} customer={customer} customerId={kennitala} checked={checkBoxes.includes(`${kennitala}-LEB`)} />}</td>
												<td><ContractTypeInput dispatch={this.props.dispatch} contractType={["FOR"]} multiTypes={true} contracts={customer.ContractsByKennitala[kennitala]} customer={customer} customerId={kennitala} checked={checkBoxes.includes(`${kennitala}-FOR`)} /></td>
												<td><button type="button" className={`btn btn-blank other-contracts-toggler ${this.state.otherContractsToggler[kennitala] ? 'active' : ''}`} onClick={this.toggleOtherContracts.bind(this, kennitala)}><i className="fa fa-chevron-up"></i>Allar tryggingar</button></td>
											</tr>
											{this.renderOtherContracts(customer.ContractsByKennitala[kennitala], kennitala)}
										</React.Fragment>
									)
								)}

							</tbody>
						</table>
					</div>
				</div>
				<div className="row">
					<div className="example-container">
						<div className="example">
							<span></span>
							<p>Virkur</p>
						</div>
						<div className="example">
							<span></span>
							<p>Biðstaða</p>
						</div>
						<div className="example">
							<span></span>
							<p>Lokaður</p>
						</div>
					</div>
				</div>
			</>
		)
	}
}

ViewContracts.defaultProps = {
}

export default ViewContracts;